import { useSearchParams } from "react-router-dom";

export const useRefId = () => {
  const [searchParams] = useSearchParams();

  return searchParams.get("ref_id") ?? "";
};
